<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">
      Manage Materials And Supply
    </h3>
    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'materials_and_supply.create', params: { id: 0 } }"
      new-button-text="New Materials And Supply"
    >
      <template slot="middle">
        <!-- <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /> -->
      </template>
    </o-list-toolbar>
    <!-- @row-selected="onRowSelected"
      :selectable="selected.selectable" :key="selected.selectable" -->
    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      :busy="working"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        slot="top-row"
        slot-scope="{ columns, fields }"
        v-if="filterRow"
      >
        <td :key="field.key" class="p-0" v-for="field in fields">
          <span v-if="field.key === 'extra__purchase_orders__date_invoiced'">
            <o-flatpickr-wrapper
              @input="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.extra__purchase_orders__date_invoiced"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'extra__purchase_orders__date_po_supplied'">
            <o-flatpickr-wrapper
              @input="filter_changed"
              class="rounded-0 px-0"
              v-model="
                list_options.qbe.extra__purchase_orders__date_po_supplied
              "
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'extra'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.extra__code"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'extra__entered_by__username'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.extra__entered_by__username"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'job__customer__name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.job__customer__name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'job__supervisor'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.job__supervisor__name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'job__id'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.job__id"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'job__site_address'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.job__site_address"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'allowed'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.allowed"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'amount_ordered'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.amount_ordered"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'amount_used'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.amount_used"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'job__pour_date'">
            <o-flatpickr-wrapper
              @input="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.job__pour_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'discrepency'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.discrepency"
            ></b-form-input>
          </span>
          <!-- <span v-if="field.key === 'extra'">
            <o-form-select
              v-model="list_options.qbe.extra"
              :options="optionServiceExtraItems"
              text-field="code"
              value-field="id"
              sort-field="code"
              blank-option-text=""
              :loading="optionServiceExtraWorking"
              @change="filter_changed"
              name="extra"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span> -->
          <span v-if="field.key === 'job'">
            <o-form-select
              v-model="list_options.qbe.job"
              :options="optionJobItems"
              text-field="site_address"
              value-field="id"
              sort-field="site_address"
              blank-option-text=""
              :loading="optionJobWorking"
              @change="filter_changed"
              name="job"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'no_allowed'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.no_allowed"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'supplier'">
            <o-form-select
              v-model="list_options.qbe.supplier"
              :options="optionSupplierItems"
              text-field="display_name"
              value-field="id"
              sort-field="display_name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'type'">
            <o-form-select
              v-model="list_options.qbe.type"
              :options="optionCodeTaskTypeItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              blank-option-text=""
              :loading="optionCodeTaskTypeWorking"
              @change="filter_changed"
              name="type"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
        </td>
      </template>
      <template slot="cell(allowed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'allowed'"
        >
          <number-display :value="item.allowed" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(amount_ordered)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount_ordered'"
        >
          <number-display :value="item.amount_ordered" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(amount_used)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount_used'"
        >
          <number-display :value="item.amount_used" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(job__pour_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'job__pour_date'"
        >
          <date-display
            :value="item.job__pour_date"
            format="DD/MM/YYYY"
            default-value="None"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(discrepency)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'discrepency'"
        >
          <number-display :value="item.discrepency" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(extra)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'extra'"
        >
          <!-- <lookup-display
            :list="optionServiceExtraItemsById"
            :value="item.extra"
            display-field="code"
            default-value="-"
          ></lookup-display> -->
          <default-display :value="item.extra__code"></default-display>
        </o-link-cell>
      </template>

      <template slot="cell(job__customer__name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'job__customer__name'"
        >
          <!-- <lookup-display
            :list="optionServiceExtraItemsById"
            :value="item.extra"
            display-field="code"
            default-value="-"
          ></lookup-display> -->
          <default-display :value="item.job__customer__name"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(extra__entered_by__username)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'extra__entered_by__username'"
        >
          <template v-if="item.extra_details">
            <default-display
              :value="item.extra_details.entered_by__username"
            ></default-display>
          </template>
          <template v-if="!item.extra_details">-</template>
          <!-- <lookup-display
            :list="optionServiceExtraItemsById"
            :value="item.extra"
            display-field="raised_by__name"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>

      <template
        slot="cell(extra__purchase_orders__date_po_supplied)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="
            first_column_key === 'extra__purchase_orders__date_po_supplied'
          "
        >
          <template v-if="item.extra_details">
            <template
              v-for="(date, index) in item.extra_details.purchase_orders"
            >
              <div :key="index">
                <date-display
                  :value="date.date_po_supplied"
                  format="DD/MM/YYYY"
                  default-value="-"
                ></date-display>
                <!-- <default-display
                  :value="date.date_po_supplied ? date.date_po_supplied : '-'"
                ></default-display> -->
              </div>
            </template>
          </template>

          <template v-if="!item.extra_details">-</template>
          <!-- <template v-if="item.extra_details">
            <ul
              v-for="(date, index) in item.extra_details.purchase_orders"
              :key="index"
            >
              <li>
                {{ date.date_po_supplied ? date.date_po_supplied : "-" }}
              </li>
            </ul>
          </template> -->

          <!-- <date-display
            :value="item.date_po_received"
            default-value="-"
          ></date-display> -->
          <!-- <lookup-display
            :list="optionServiceExtraItemsById"
            :value="item.extra"
            display-field="date_po_requested"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>

      <template
        slot="cell(extra__purchase_orders__date_invoiced)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'extra__purchase_orders__date_invoiced'"
        >
          <date-display
            :value="item.extra__purchase_orders__date_invoiced"
            format="DD/MM/YYYY"
            default-value="-"
          ></date-display>
          <!-- <default-display
            :value="item.extra__purchase_orders__date_invoiced"
            format="DD/MM/YYYY"
            default-value="-"
          ></default-display> -->
          <!-- <template v-if="item.extra_details">
            <template
              v-for="(date, index) in item.extra_details.purchase_orders"
            >
              <div :key="index">
                <date-display
                  :value="date.date_invoiced"
                  format="DD/MM/YYYY"
                  default-value="-"
                ></date-display>

              </div>
            </template>
          </template>
          <template v-if="!item.extra_details">-</template> -->
          <!-- <template v-if="item.extra_details">
            <ul
              v-for="(date, index) in item.extra_details.purchase_orders"
              :key="index"
            >
              <li>
                {{
                  date.date_invoiced ? date.date_invoiced : "-"
                }}
              </li>
            </ul>
          </template> -->

          <!-- <lookup-array-display
            :list="optionServiceExtraItemsById"
            :value="item.extra"
            display-field="purchase_orders"
            default-value="-"
          ></lookup-array-display> -->
        </o-link-cell>
      </template>

      <template slot="cell(job)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display :value="item.job__site_address"></default-display>
          <!-- <lookup-display
            :list="optionJobItemsById"
            :value="item.job"
            display-field="site_address"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>
      <template slot="cell(job__site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display
            :value="item.job_details.site_address"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(job_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'job_no'"
        >
          <default-display :value="item.job"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(no_allowed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'no_allowed'"
        >
          <boolean-display :value="item.no_allowed"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(supplier)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.supplier"
            display-field="display_name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'materials_and_supply.edit', params: { id: item.id } }"
          :when="first_column_key === 'type'"
        >
          <lookup-display
            :list="optionCodeTaskTypeItemsById"
            :value="item.type"
            display-field="description"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'materials_and_supply.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import { default as SupplierTypeMixin } from "../../job/mixins/supplier_type_mixin.js";

import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import LookupArrayDisplay from "../../components/look_up_array_display/LookupArrayDisplay.vue";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
    LookupArrayDisplay,
  },
  mixins: [
    CreateListPageMixin("MaterialsAndSupply", "materials_and_supply", "all"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("MaterialsAndSupply"),
    CreateCodeTableFetchMixin(["Supplier", "CodeTaskType", "CodeSupplierType"]),
    SupplierTypeMixin,
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.MaterialsAndSupply,
        {}
      ) /*Use this.schema instead */,

      // search_field_list: GetSearchFields(schema.MaterialsAndSupply),
      search_field_list: [
        { text: "-- All --", value: "" },
        { text: "Job Address", value: "job__site_address" },
        { text: "Supplier", value: "supplier__name" },
        { text: "Type", value: "type__description" },
        { text: "Customer", value: "job__customer__name" },
        // { text: "Customer", value: "job__customer" },
        { text: "Extra", value: "extra__code" },
        // { text: "Job No", value: "job_no" },
        { text: "Job No", value: "job__id" },
        { text: "Job Supervisor", value: "job__supervisor__name" },
        // { text: "Job Supervisor", value: "job__supervisor" },
        // { text: "Extra Requested By", value: "extra_raised_by" },
        // { text: "Extra Requested By", value: "extra__raised_by" },
        { text: "Extra Requested By", value: "extra__entered_by__username" },
        { text: "Extra Ref. No.", value: "extra__code" },
        // { text: "Date PO Received", value: "date_po_received" },
        {
          text: "Date PO Received",
          value: "extra__purchase_orders__date_po_supplied",
        },
        // { text: "Date Invoiced", value: "date_po_invoiced" },
        {
          text: "Date Invoiced",
          value: "extra__purchase_orders__date_invoiced",
        },
      ],

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "job__id" } },
        {
          name: "Missing Used",
          code: "missing_used",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "No Discrepancy",
          code: "no_discrepancy",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Ready To Invoice",
          code: "ready_to_invoice",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Waiting for PO",
          code: "waiting_for_po",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Invoiced",
          code: "invoiced",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Allowance Not Provided",
          code: "allowance_not_provided",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "No Extra Created",
          code: "no_extra_created",
          options: { offset: 0, sort: "id" },
        },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  methods: {
    rowClass(item, type) {
      if (item && type === "row") {
        return this.cell_style(null, "", item);
      } else {
        return null;
      }
    },
    cell_style(value, key, item) {
      if (key === "allowed" || key === "amount_used" || key === "discrepency") {
        return "text-right";
      }
      return null;
    },
    addTdClass(entries) {
      entries.forEach(function (entry) {
        if (entry) {
          entry["tdClass"] = "cell_style";
        }
      });
    },
  },
  computed: {
    options() {
      return {
        Supplier: {
          options: this.optionSupplierItems,
          textField: "name",
          valueField: "id",
        },
        CodeTaskType: {
          options: this.optionCodeTaskTypeItems,
          textField: "description",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "job__pour_date",

        "type",
        "job__id",
        "job__site_address",
        "job__supervisor",
        "job__customer__name",
        "supplier",

        "allowed",
        "amount_used",
        "discrepency",
        "extra__entered_by__username",

        "extra",
        "extra__purchase_orders__date_po_supplied",
        "extra__purchase_orders__date_invoiced",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      this.addTdClass(this.filterTableColumns(this.schema, fields));

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
